import { z } from "zod"

export const DurationSchema = z.object({
  sO: z.number().describe("Source offset start (ms)"),
  eO: z.number().describe("Source offset end (ms)"),
  type: z.literal("TS").default("TS"),
})

export const TimelineSchema = z.object({
  in: z.number().describe("Output timeline start (ms)"),
  out: z.number().describe("Output timeline end (ms)"),
})

export const PositionSchema = z.object({
  type: z.literal("CPct").default("CPct"),
  xPct: z.number().min(-1).max(1).default(0),
  yPct: z.number().min(-1).max(1).default(0),
  wPct: z.number().min(0).max(1).default(1),
  hPct: z.number().min(0).max(1).default(0.1),
})

export type Duration = z.infer<typeof DurationSchema>
export type Timeline = z.infer<typeof TimelineSchema>
export type Position = z.infer<typeof PositionSchema>
